import { Link } from "react-router-dom";
import { translateStatus } from "../../single-order";
import ServiceSuggestion from "../../../../components/services/service-suggestion";

const OrderInfo = ({ order, setShowStatusForm, allowedStatuses }) => {
    return (
        <>
            {/* Order Header Section */}
            <div className="border-b pb-4 mb-4">
                <h2 className="text-xl font-semibold text-gray-800">
                    {order.negotiation.type === "Service" ? "الخدمة" : "المنتج: "}
                    <span className="text-primary-600">{order.item_name}</span>
                </h2>
                <div className="flex flex-wrap gap-4 mt-2">
                    <p className="text-gray-600 bg-gray-100 px-3 py-1 rounded-full text-sm">
                        رقم الطلب: <span className="font-medium">{order.id}</span>
                    </p>
                    <p className="text-gray-500 bg-gray-100 px-3 py-1 rounded-full text-sm">
                        تم الإنشاء في: {new Date(order.createdAt).toLocaleDateString("ar-EG", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                        })}
                    </p>
                </div>
            </div>

            {/* Order Details Section */}
            <div className="border-b pb-4 mb-4 flex flex-col md:flex-row gap-4 items-start">
                <img
                    src={order.item_img}
                    alt="صورة المحصول"
                    className="w-full md:w-32 h-32 object-cover rounded-md border shadow-sm"
                />
                <div className="w-full">
                    <h2 className="text-lg font-semibold text-gray-800 mb-2">تفاصيل الطلب</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <div className="bg-gray-50 p-3 rounded-lg">
                            <p className="text-gray-500 text-sm">الكمية</p>
                            <p className="font-medium">{order.quantity} طن</p>
                        </div>
                        <div className="bg-gray-50 p-3 rounded-lg">
                            <p className="text-gray-500 text-sm">السعر الإجمالي</p>
                            <p className="font-medium">{order.price} جنيه</p>
                        </div>
                        <div className="bg-gray-50 p-3 rounded-lg sm:col-span-2">
                            <p className="text-gray-500 text-sm">حالة الطلب</p>
                            <span
                                className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${order.status === "Pending"
                                    ? "bg-yellow-100 text-yellow-800"
                                    : order.status === "Processing"
                                        ? "bg-blue-100 text-blue-800"
                                        : order.status === "Shipped"
                                            ? "bg-purple-100 text-purple-800"
                                            : order.status === "Delivered"
                                                ? "bg-green-100 text-green-800"
                                                : order.status === "Paid"
                                                    ? "bg-emerald-100 text-emerald-800"
                                                    : order.status === "Cancelled"
                                                        ? "bg-red-100 text-red-800"
                                                        : "bg-gray-100 text-gray-800"
                                    }`}
                            >
                                {translateStatus(order.status)}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Buyer/Seller Section */}
            <div className="border-b pb-4 mb-4">
                <h2 className="text-lg font-semibold text-gray-800 mb-3">التاجر / المشتري</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="bg-gray-50 p-4 rounded-lg">
                        <p className="text-gray-500 text-sm mb-1">المشتري</p>
                        <p className="font-medium">{order.negotiation?.buyer.name}</p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg">
                        <p className="text-gray-500 text-sm mb-1">البائع</p>
                        <p className="font-medium">{order.negotiation?.seller.name}</p>
                    </div>
                </div>
            </div>

            {/* Delivery Section */}
            <div className="pb-4">
                <h2 className="text-lg font-semibold text-gray-800 mb-3">التوصيل</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    <div className="bg-gray-50 p-4 rounded-lg">
                        <p className="text-gray-500 text-sm mb-1">تاريخ التوصيل المتوقع</p>
                        <p className="font-medium">
                            {new Date(order.deliveryDate).toLocaleDateString("ar-EG", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                            })}
                        </p>
                    </div>
                </div>
                
               <ServiceSuggestion />
            </div>
        </>
    );
};

export default OrderInfo;

// import { Link } from "react-router-dom";
// import { translateStatus } from "../../single-order";


// const OrderInfo = ({ order, setShowStatusForm, allowedStatuses }) => {
//     return (
//         <>

//             <div className="border-b pb-4 mb-4">
//                 <h2 className="text-xl font-semibold">
//                     {order.negotiation.type === "Service" ? "الخدمة" : "المنتج: "}
//                     {order.item_name}
//                 </h2>
//                 <p className="text-gray-600">رقم الطلب: {order.id}</p>
//                 <p className="text-gray-500 text-sm">
//                     تم الإنشاء في: {new Date(order.createdAt).toLocaleDateString("ar-EG", {
//                         year: "numeric",
//                         month: "long",
//                         day: "numeric",
//                     })}
//                 </p>
//             </div>

//             <div className="border-b pb-4 mb-4 flex gap-4 items-start">
//                 <img
//                     src={order.item_img}
//                     alt="صورة المحصول"
//                     className="w-32 h-32 object-cover rounded-md border"
//                 />
//                 <div>
//                     <h2 className="text-lg font-semibold">تفاصيل الطلب</h2>
//                     <p className="text-gray-600">الكمية: {order.quantity} طن</p>
//                     <p className="text-gray-600">السعر الإجمالي: {order.price} جنيه</p>
//                     <p className="text-gray-600">
//                         حالة الطلب:
//                         <span
//                             className={`ml-2 px-2 py-1 rounded ${order.status === "Pending"
//                                 ? "bg-yellow-200 text-yellow-800"
//                                 : order.status === "Processing"
//                                     ? "bg-blue-200 text-blue-800"
//                                     : order.status === "Shipped"
//                                         ? "bg-purple-200 text-purple-800"
//                                          : order.status === "Delivered"
//                                             ? "bg-green-200 text-green-800"
//                                         : order.status === "Paid"
//                                             ? "bg-emerald-200 text-emerald-800"
//                                             : order.status === "Cancelled"
//                                                 ? "bg-red-200 text-red-800"
//                                                 : "bg-gray-200 text-gray-800"
//                                 }`}
//                         >
//                                {translateStatus(order.status)}
//                         </span>
//                     </p>

                   
//                 </div>
//             </div>


//             <div className="border-b pb-4 mb-4">
//                 <h2 className="text-lg font-semibold">التاجر / المشتري</h2>
//                 <p className="text-gray-600">المشتري: {order.negotiation?.buyer.name}</p>
//                 <p className="text-gray-600">البائع: {order.negotiation?.seller.name}</p>
//             </div>

//             <div>
//                 <h2 className="text-lg font-semibold">التوصيل</h2>
//                 <p className="text-gray-600">
//                     تاريخ التوصيل المتوقع: {new Date(order.deliveryDate).toLocaleDateString("ar-EG", {
//                         year: "numeric",
//                         month: "long",
//                         day: "numeric",
//                     })}
//                 </p>
//                 <p className="text-gray-600">
//                     يمكنك طلب خدمة نقل او تخزين: 
//                     <Link to={"/home/services"} className="text-blue-500 hover:underline">
//                     من هنا
//                     </Link>
//                 </p>
//             </div>
//         </>
//     );
// };

// export default OrderInfo;